// Talep 833 kural 2 — Oturum açan kullanıcı DİSTRİBÜTÖR tipi mi, öyleyse hangi distribütöre bağlı?
//
// Bu bilgiyi isteyen her ekran (belge ekranları + tanım kartları) aynı kaynaktan okusun diye
// hook'a çıkarıldı; ekran başına fetch kopyalamak, birinin unutulup kilidi açık bırakması demekti.
// Sonuç modül düzeyinde ÖNBELLEKLENİR: kullanıcının distribütörlüğü oturum boyunca değişmez,
// her ekran açılışında ağ turu atmasına gerek yok.
//
// Kullanım:
//   const { isDistributor, vendorId, loading } = useDistributorUser();
//   // Distribütör alanı: value = isDistributor ? vendorId : form.vendorId
//   //                    disabled = isDistributor
//
// Sözleşme: admin ve distribütör OLMAYAN kullanıcıda { isDistributor: false, vendorId: '' } döner
// → alan kilitlenmez. Uç hata verirse de aynı "kilitleme" sonucu üretilir: kilit bir YETKİ değil
// bir KOLAYLIK'tır (asıl daraltma /api/vendors/Select'te yapılır), o yüzden fail-open güvenlidir.
import { useState, useEffect } from 'react';
import { authHeaders } from '../components/listPageStyles';

const NOT_DISTRIBUTOR = { isDistributor: false, vendorId: '', vendorName: '' };

// Oturum boyunca tek istek — paralel çağıranlar aynı promise'i paylaşır.
let cached = null;
let inFlight = null;

async function fetchDistributorUser() {
  if (cached) return cached;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const res = await fetch('/api/document-defaults/distributor-user', { headers: authHeaders() });
      if (!res.ok) return NOT_DISTRIBUTOR;
      const body = await res.json();
      const d = body?.data ?? body?.Data ?? body;
      cached = {
        isDistributor: !!(d?.isDistributor ?? d?.IsDistributor),
        vendorId: d?.vendorId ?? d?.VendorId ?? '',
        vendorName: d?.vendorName ?? d?.VendorName ?? '',
      };
      // Bayrak açık ama distribütör çözülememişse kilitleme — boş bir değere kilitlenen alan
      // belgenin hiç kesilememesi demek olurdu.
      if (!cached.vendorId) cached = NOT_DISTRIBUTOR;
      return cached;
    } catch {
      return NOT_DISTRIBUTOR;
    } finally {
      inFlight = null;
    }
  })();
  return inFlight;
}

/** Test/oturum değişimi için önbelleği düşürür (logout akışı çağırmalıdır). */
export function resetDistributorUserCache() {
  cached = null;
  inFlight = null;
}

/**
 * @returns {{ isDistributor: boolean, vendorId: string, vendorName: string, loading: boolean }}
 */
export function useDistributorUser() {
  const [state, setState] = useState(() => cached || NOT_DISTRIBUTOR);
  const [loading, setLoading] = useState(!cached);

  useEffect(() => {
    if (cached) { setState(cached); setLoading(false); return undefined; }
    let alive = true;
    fetchDistributorUser().then((d) => {
      if (!alive) return;
      setState(d);
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  return { ...state, loading };
}

export default useDistributorUser;
